import { AnyAction } from 'redux';
import { ErrorData } from '@synergy/api';

import { PRODUCT_DETAIL_RESET } from '../../store/product-detail-actions';
import {
    PRODUCT_DETAIL_VARIANTS_ADDED,
    PRODUCT_DETAIL_VARIANTS_ERROR,
    PRODUCT_DETAIL_VARIANTS_RECEIVE,
    PRODUCT_DETAIL_VARIANTS_REMOVED,
    PRODUCT_DETAIL_VARIANTS_STATUS_CHANGE,
} from './product-detail-variants-actions';
import { ProductVariant } from '../models/product-detail-variant';

export interface ProductDetailVariantsReducerState {
    variants: ProductVariant[] | null;
    requestError?: ErrorData;
}

const initialProductDetailVariantsReducerState: ProductDetailVariantsReducerState = {
    variants: null,
};

export const productDetailVariantsReducer = (
    state: ProductDetailVariantsReducerState = initialProductDetailVariantsReducerState,
    action: AnyAction
): ProductDetailVariantsReducerState => {
    switch (action.type) {
        case PRODUCT_DETAIL_RESET: {
            return initialProductDetailVariantsReducerState;
        }

        case PRODUCT_DETAIL_VARIANTS_STATUS_CHANGE: {
            const newVariants = [...(state.variants || [])];
            const index = newVariants.findIndex(variant => variant.id === action['variantId']);

            if (index < 0) {
                return state;
            }

            newVariants[index].isActive = action['status'];

            return {
                ...state,
                variants: newVariants,
            };
        }

        case PRODUCT_DETAIL_VARIANTS_RECEIVE: {
            return {
                ...state,
                variants: action['variants'],
            };
        }

        case PRODUCT_DETAIL_VARIANTS_ADDED: {
            return {
                ...state,
                variants: [...(state.variants || []), action['variant']],
            };
        }

        case PRODUCT_DETAIL_VARIANTS_REMOVED: {
            return {
                ...state,
                variants: state.variants?.filter(variant => variant.id !== action['productId']) || null,
            };
        }

        case PRODUCT_DETAIL_VARIANTS_ERROR: {
            return {
                ...state,
                requestError: action['errorData'],
            };
        }

        default: {
            return state;
        }
    }
};
